import getUseridInfoService  from '../services/components/userid_info.jsx'


const getState = (useridInfoState) => ({ type: "USERID_INFO", useridInfoState })


export const userIdInfoAction = (userid) => dispatch => {
    let state = [];

    getUseridInfoService((data, msg) => {

        if (msg === "success") {

            state = {
                status: 200,
                body: data
            }
       
        }
        else if(msg === "sessionout"){
            state={
                message: "sessionout",
                status: 401,
                body: data 
            }
        }
        else {
            state = data
        }
        dispatch(getState(state))
    }, userid)
} 


// WEBPACK FOOTER //
// ./src/actions/useridinfoaction.jsx